import React, { Component } from "react";
import { Link } from "react-router-dom";
import { StyledHero } from "../components/Styled";
import hero from "../images/background7.jpg";
import data from "../data/data";

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "",
      name: "",
      email: "",
      subject: "",
      error: "",
      success: "",
    };
  }

  //handle value change on key press by the user in the input field and textarea
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  //Handle form submition
  handleSubmit = async (e) => {
    //prevent the default form action
    e.preventDefault();

    try {
      const configOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.state),
      };

      //send the input field to a backend API service for processing

      const response = await fetch(
        "https://sheldon-portfolio.herokuapp.com/api/v1/contact",
        configOptions
      );
      
      if(!response.ok){
        throw Error("Error trying to send the mail. Please try again later or reach out directly via the mail");
      }

      const { message, error } = await response.json();

      if (message) {
        this.setState({ success: message });
      } else {
        this.setState({ error });
      }

      setTimeout(() => {
        this.setState({
          success: "",
          error: "",
        });
      }, 7000);
    } catch (err) {
      this.setState({
        error: err.message,
      });
    }

    //clear the input values on form submition
    this.setState({
      message: "",
      name: "",
      email: "",
      subject: "",
    });
  };

  render() {
    //destructure the values in the state
    const { message, name, email, subject, success, error } = this.state;
    const contacts = [...data.contacts];

    return (
      <div className="page-height contacts">
        <StyledHero image={hero}>
          <h3>Contact Me</h3>
          <p>
            <Link to="/">Home</Link> / Contact Me
          </p>
        </StyledHero>
        <div className="section-one">
          <p>
            Do you have any queries or comments regarding my work?
            <br />
            Get in touch here!
          </p>
        </div>
        {success && <div className="success-msg">{success}</div>}
        {error && <div className="error-msg">{error}</div>}
        <div className="section-two">
          <div className="form-border">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <h2 className="title">Get in Touch</h2>
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  id="message"
                  cols="30"
                  rows="5"
                  placeholder="Enter Message"
                  className="form-control"
                  value={message}
                  onChange={this.handleChange}
                  required
                ></textarea>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className="form-control"
                    placeholder="Enter your name"
                    value={name}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  className="form-control"
                  placeholder="Subject"
                  value={subject}
                  onChange={this.handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <button className="btn btn-primary" type="submit">
                  Send
                </button>
              </div>
            </form>
          </div>
          <div className="contacts-info">
            {contacts.map((item, index) => (
              <p key={index}>
                <i className={item["icon-class"]}></i>
                <span className="info">
                  <span>{item.info}</span> <br />
                  <span>{item.moreInfo}</span>
                </span>
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
